import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../shared/services/user.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RazorpayService} from '../../shared/services/razorpay.service';

@Component({
    selector: 'app-my-wallet',
    templateUrl: './my-wallet.component.html',
    styleUrls: ['./my-wallet.component.scss'],
})
export class MyWalletComponent implements OnInit {
    userData: any;
    totalAmount: any;
    addMoneyToWalletForm: FormGroup;
    submitted: any;

    constructor(private router: Router,
                private fb: FormBuilder,
                private userService: UserService,
                private razorpayService: RazorpayService) {
    }

    ngOnInit(): void {
        this.refersh();
        this.getUserDetail();

    }

    getUserDetail() {
        this.userService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                const walletAmount = (this.userData && this.userData['wallet_amount']) ? parseFloat(this.userData['wallet_amount']) : 0;
                const activationAmount = (this.userData && this.userData['activation_amount']) ? parseFloat(this.userData['activation_amount']) : 0;
                this.totalAmount = walletAmount + activationAmount;
            }
        });
    }

    refersh() {
        this.addMoneyToWalletForm = this.fb.group({
            'amount': ['', Validators.required],
        });
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }

    addMoneyToWallet(data) {
        this.submitted = true;
        if (!this.addMoneyToWalletForm.valid) {
            return;
        }
        if (this.submitted) {
            const orderDetails = {
                'amount': (this.addMoneyToWalletForm && this.addMoneyToWalletForm.getRawValue() && this.addMoneyToWalletForm.getRawValue().amount) ? this.addMoneyToWalletForm.getRawValue().amount + '00' : '',
                'currency': 'INR',
            };
            this.razorpayService.genrateOrderId(orderDetails).subscribe(dd => {
                if (dd && dd.id) {
                    const params = {
                        'amount': (this.addMoneyToWalletForm && this.addMoneyToWalletForm.getRawValue() && this.addMoneyToWalletForm.getRawValue().amount) ? this.addMoneyToWalletForm.getRawValue().amount + '00' : '',
                        'name': data.name,
                        'email': data.email,
                        'contact': data.contact,
                        'order_id' : dd.id,
                    };
                    this.razorpayService.initializePayment(params);
                    this.razorpayService.getPaymentResponseObservable().subscribe((response) => {
                        this.handlePaymentResponse(response, dd.id);
                    });
                }
            });
        }
    }

    handlePaymentResponse(response: any, orderid:any) {
        const params = {
            'payment_status': 'COMPLETED',
            'amount': (this.addMoneyToWalletForm && this.addMoneyToWalletForm.getRawValue() && this.addMoneyToWalletForm.getRawValue().amount) ? this.addMoneyToWalletForm.getRawValue().amount : '',
            'session_id': this.userData.session_id,
            'transaction_id': response.razorpay_payment_id,
            'order_id': orderid,
        };
        this.userService.addMoneyInWallet(this.userData.unique_id, params).subscribe(data => {
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        });
    }

}
